import { createContext, type ReactNode } from "react";

/** Tour state for the step tooltip; null when no tour runs. Without a guide, `slot` is null. */
export interface WalkthroughTooltipGuide {
	registerTooltip: (element: HTMLElement | null) => void;
	slot: ReactNode;
	showWrongClickHint: boolean;
}

export const WalkthroughTooltipGuideContext = createContext<WalkthroughTooltipGuide | null>(null);
